import React from 'react';

export const ApplicationsContext = React.createContext<{
  hoveredApplication?: string;
  setHoveredApplication: (s?: string) => void;
}>({} as any);

class ApplicationsData extends React.Component<
  {
    children: React.ReactNode;
  },
  {
    hoveredApplication?: string;
  }
> {
  state = {
    hoveredApplication: undefined,
  };

  setHoveredApplication = (hoveredApplication?: string) => {
    if (hoveredApplication !== this.state.hoveredApplication) {
      this.setState({ hoveredApplication });
    }
  };
  render() {
    const { hoveredApplication } = this.state;
    const { children } = this.props;
    return (
      <ApplicationsContext.Provider
        value={{
          hoveredApplication,
          setHoveredApplication: this.setHoveredApplication,
        }}
      >
        {children}
      </ApplicationsContext.Provider>
    );
  }
}

export default ApplicationsData;
